<h1 mat-dialog-title>{{ data.title }}</h1>

<div
  mat-dialog-content
  [formGroup]="form"
  [ngClass]="[
    layout.columns > 1 ? 'flex flex-wrap gap-' + layout.gap + 'percent' : 'layout-column',
    'responsive-column'
  ]"
>
  @for (formfield of formfields; track formfield) {
    <div [ngClass]="'flex-' + layout.flex + ' responsive-flex-full'">
      <LOSx-formfield [formfield]="formfield" [form]="form" class="flex-fill"></LOSx-formfield>
    </div>
  }
</div>

<mat-dialog-actions class="layout-row layout-xs-column layout-align-center gap-2percent" align="end">
  <button mat-raised-button mat-dialog-close>{{ 'labels.buttons.' + layout.cancelButtonText | translate }}</button>
  <button
    mat-raised-button
    color="primary"
    [mat-dialog-close]="{ data: form }"
    [disabled]="!form.valid || form.pristine"
  >
    {{ 'labels.buttons.' + layout.addButtonText | translate }}
  </button>
</mat-dialog-actions>
